// Version : 1.0.0
// Author : AGALYA

/* eslint-disable import/no-anonymous-default-export */
import ResidentialDetailsActionType from './residential-details.types';

const INITIAL_STATE = {
	// Residential Details Response
	residentialDetailsResponse: null,
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** Residential Address Add Start ************************/
		case ResidentialDetailsActionType.RESIDENTIAL_DETAILS_ADD_SUCCESS:
			return { ...state, residentialDetailsResponse: action.payload };

		case ResidentialDetailsActionType.RESIDENTIAL_DETAILS_ADD_FAILURE:
			return { ...state, residentialDetailsResponse: action.payload };

		case ResidentialDetailsActionType.RESIDENTIAL_DETAILS_ADD_RESPONSE_CHANGED:
			return { ...state, residentialDetailsResponse: null };

		/** ***************** Residential Address Add End ************************/

		default:
			return state;
	}
};
